import { CalloutExpandable } from './components/expandable';
import { Callout as CalloutComponent } from './components/plain';
import { CalloutSection } from './parts/section';

export const Callout = Object.assign(CalloutComponent, {
  Expandable: CalloutExpandable,
  Section: CalloutSection
});
